const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const getAuthHeaders = () => {
     const token = sessionStorage.getItem('token');
     console.log('Token from sessionStorage:', token); // Debug
     return {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
     };
};

const handleResponse = async (response) => {
     if (!response.ok) {
          const error = await response.json().catch(() => ({ message: 'Request failed' }));
          throw new Error(error.message || `HTTP error! status: ${response.status}`);
     }
     return response.json();
};

// Leave Balance APIs
export const getLeaveBalances = async (empCode, year) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-balances/${empCode}?year=${year}`,
               {
                    method: 'GET',
                    headers: getAuthHeaders()
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error fetching leave balances:', error);
          throw error;
     }
};



// Credit Leaves to Employees
export const creditLeaves = async (creditData) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-balances/credit`,
               {
                    method: 'POST',
                    headers: getAuthHeaders(),
                    body: JSON.stringify(creditData)
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error crediting leaves:', error);
          throw error;
     }
};

// Bulk Credit Leaves
export const bulkCreditLeaves = async (bulkData) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-balances/bulk-credit`,
               {
                    method: 'POST',
                    headers: getAuthHeaders(),
                    body: JSON.stringify(bulkData)
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error bulk crediting leaves:', error);
          throw error;
     }
};

// Leave Requests APIs
export const getLeaveRequests = async (filters = {}) => {
     try {
          const queryParams = new URLSearchParams(filters).toString();
          const response = await fetch(
               `${API_BASE_URL}/leave-requests?${queryParams}`,
               {
                    method: 'GET',
                    headers: getAuthHeaders()
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error fetching leave requests:', error);
          throw error;
     }
};

export const createLeaveRequest = async (requestData) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-requests`,
               {
                    method: 'POST',
                    headers: getAuthHeaders(),
                    body: JSON.stringify(requestData)
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error creating leave request:', error);
          throw error;
     }
};

export const approveLeaveRequest = async (requestId, remarks) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-requests/${requestId}/approve`,
               {
                    method: 'PUT',
                    headers: getAuthHeaders(),
                    body: JSON.stringify({ remarks })
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error approving leave request:', error);
          throw error;
     }
};

export const rejectLeaveRequest = async (requestId, remarks) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-requests/${requestId}/reject`,
               {
                    method: 'PUT',
                    headers: getAuthHeaders(),
                    body: JSON.stringify({ remarks })
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error rejecting leave request:', error);
          throw error;
     }
};

// Leave Transactions/Statement
export const getLeaveTransactions = async (empCode, startDate, endDate) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-transactions/${empCode}?start=${startDate}&end=${endDate}`,
               {
                    method: 'GET',
                    headers: getAuthHeaders()
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error fetching leave transactions:', error);
          throw error;
     }
};

export const getMonthlyLeaveReport = async (empCode, year, month) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-transactions/monthly/${empCode}?year=${year}&month=${month}`,
               {
                    method: 'GET',
                    headers: getAuthHeaders()
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error fetching monthly leave report:', error);
          throw error;
     }
};

export const getLeaveStatement = async (empCode, financialYear) => {
     if (!empCode) throw new Error("empCode is required");
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-statement/${empCode}?fy=${financialYear}`,
               {
                    method: 'GET',
                    headers: getAuthHeaders()
               }
          );
          const result = await handleResponse(response);
          console.log('Leave Statement API Response:', result);
          return result;
     } catch (error) {
          console.error('Error fetching leave statement:', error);
          throw error;
     }
};

// export const getLeaveStatement = async (empCode, financialYear) => {
//      try {
//           const response = await fetch(
//                `${API_BASE_URL}/leave-statement/${empCode}?fy=${financialYear}`,
//                {
//                     method: 'GET',
//                     headers: getAuthHeaders()
//                }
//           );
//           return await handleResponse(response);
//      } catch (error) {
//           console.error('Error fetching leave statement:', error);
//           throw error;
//      }
// };

// Deduct leaves when request is approved
export const deductLeaves = async (deductData) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-balances/deduct`,
               {
                    method: 'POST',
                    headers: getAuthHeaders(),
                    body: JSON.stringify(deductData)
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error deducting leaves:', error);
          throw error;
     }
};

// Get leave history for an employee
export const getLeaveHistory = async (empCode, year) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-requests/history/${empCode}?year=${year}`,
               {
                    method: 'GET',
                    headers: getAuthHeaders()
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error fetching leave history:', error);
          throw error;
     }
};

export const getLeaveBalancesAll = async (year) => {
     const response = await fetch(`/api/leave-balances/all?year=${year}`);
     return await response.json();
};

export const getAllEmployeeBalances = async (year) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-balances/all?year=${year}`,
               {
                    method: 'GET',
                    headers: getAuthHeaders()
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error fetching all employee balances:', error);
          throw error;
     }
};

// Get pending leave requests for manager
export const getPendingRequests = async (managerId) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-requests/pending/${managerId}`,
               {
                    method: 'GET',
                    headers: getAuthHeaders()
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error fetching pending requests:', error);
          throw error;
     }
};

// Cancel leave request
export const cancelLeaveRequest = async (requestId, reason) => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-requests/${requestId}/cancel`,
               {
                    method: 'PUT',
                    headers: getAuthHeaders(),
                    body: JSON.stringify({ reason })
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error canceling leave request:', error);
          throw error;
     }
};

// Get leave types
export const getLeaveTypes = async () => {
     try {
          const response = await fetch(
               `${API_BASE_URL}/leave-types`,
               {
                    method: 'GET',
                    headers: getAuthHeaders()
               }
          );
          return await handleResponse(response);
     } catch (error) {
          console.error('Error fetching leave types:', error);
          throw error;
     }
};

// Export for CSV/Excel
export const exportLeaveReport = async (filters, format = 'csv') => {
     try {
          const queryParams = new URLSearchParams({ ...filters, format }).toString();
          const response = await fetch(
               `${API_BASE_URL}/leave-reports/export?${queryParams}`,
               {
                    method: 'GET',
                    headers: getAuthHeaders()
               }
          );

          if (!response.ok) {
               throw new Error('Export failed');
          }

          const blob = await response.blob();
          return blob;
     } catch (error) {
          console.error('Error exporting leave report:', error);
          throw error;
     }
};